import React, { PropsWithChildren } from 'react';
import { RequiredSymbol } from '../../partials/RequiredSymbol/RequiredSymbol';
import { Help } from '../../partials/Help/Help';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export type Label = PropsWithChildren<{
  htmlFor: string;
  required?: boolean;
  helpText?: string;
  helpTextId?: string;
  tooltipPlacement?: TooltipPlacement;
}>;

/**
 * Label for an Input/Control which contains vital information on how to use it
 */
export function Label({ htmlFor, required, helpText, helpTextId, tooltipPlacement, children }: Label) {
  return (
    <span className="form2-label__container">
      <label htmlFor={htmlFor} className="form2-label font-bold-15-19">
        {children}
        {required && <RequiredSymbol />}
      </label>
      {helpText && helpTextId && <Help helpText={helpText} id={helpTextId} tooltipPlacement={tooltipPlacement} />}
    </span>
  );
}
